var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import React, { useEffect, useState } from "react";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import SignOnMandate from "./SignOnMandate";
import CreateNewMandateData from "./CreateNewMandateData";
import { EMutualFundFlow } from "../MutualFund";
import tocDi from "@frameworks/web/components/features/TOC/di/servicelocator";
import NewMandate from "./NewMandate";
import { base64toPDFforceDownload } from "@frameworks/web/utils/base64_functions";
import EmandateInfoPage from "./EmandateInfoPage";
import * as URLConfig from "@frameworks/salesjourney/config/domain";
import SideTxnFooter from "../SideTxnFooter";
import MandateStatus from "@frameworks/shared-library/assets/images/SalesJourney/mandate-status.svg";
import moment from "moment";
import GenericStatus, { EGenericStatusType, } from "@frameworks/shared-library/components/GenericStatus/GenericStatus";
import { EValueType, } from "@frameworks/shared-library/components/GenericDetails/GenericDetails";
import { EMandateType } from "../MutualFundConstant";
import { Toast, ToastContainer } from "react-bootstrap";
import Edelicon from "@frameworks/web/components/generic/Edelicon";
import { useNavigate } from "react-router-dom";
import { EProductIds, ESubProductIds, } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import Loader from "@frameworks/web/components/generic/loader";
var config = URLConfig.config;
var urlMapper = (_a = {},
    _a[ESubProductIds.MutualFund] = EProductIds.MANAGED_PORTFOLIO,
    _a);
export var EMandateFlow;
(function (EMandateFlow) {
    EMandateFlow["CREATE"] = "CREATE";
    EMandateFlow["UPLOAD"] = "UPLOAD";
    EMandateFlow["LOADER"] = "LOADER";
    EMandateFlow["SHOW"] = "SHOW";
    EMandateFlow["INFOPAGE"] = "INFOPAGE";
})(EMandateFlow || (EMandateFlow = {}));
var CreateNewMandate = function (props) {
    var device = DeviceContext();
    var navigate = useNavigate();
    // let window2: Window = null;
    // const isImpersonated = window.localStorage.getItem("isImpersonated");
    // const cipDetails = JSON.parse(window.sessionStorage.getItem("cipDetails"));
    var _a = __read(useState(EMandateType.EMANDATE), 2), mandateType = _a[0], setMandateType = _a[1];
    var _b = __read(useState(props.selectedMandate), 2), newMandate = _b[0], setNewMandate = _b[1];
    var _c = __read(useState("50000"), 2), amount = _c[0], setAmount = _c[1];
    var _d = __read(useState(true), 2), disableSubmit = _d[0], setDisableSubmit = _d[1];
    var _e = __read(useState({
        amount: { msg: "", status: false },
    }), 2), formErrors = _e[0], setFormErrors = _e[1];
    var _f = __read(useState(""), 2), showToastMsg = _f[0], setShowToastMsg = _f[1];
    var _g = __read(useState([]), 2), genericDetailsProps = _g[0], setGenericDetailsProps = _g[1];
    // const getMandateUrl = (mandateID: string) => {
    //   tocDi.mandate
    //     .getEmandateUrl({
    //       mandateId: mandateID,
    //       clientCode: props.clientDetails.clientCode,
    //     }) //need to change as per acctype of client
    //     .then((data) => {
    //       if (data && data.message) window2.location.href = data.message;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       setDisableSubmit(true);
    //       window2.location.href =
    //         config.rmJourneyBaseRoot + "mutualFunds/closing";
    //       setTimeout(() => {
    //         setShowToastMsg(
    //           "Facing some technical difficulties, please try later"
    //         );
    //       }, 2500);
    //     });
    // };
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            if (formErrors.amount.status && !props.selectedBank)
                return [2 /*return*/];
            props === null || props === void 0 ? void 0 : props.setMandateFlow(EMandateFlow.LOADER);
            payload = {
                mndAmt: amount,
                bnkNm: (_a = props.selectedBank) === null || _a === void 0 ? void 0 : _a.bnkNm,
                brn: (_b = props.selectedBank) === null || _b === void 0 ? void 0 : _b.brn,
                bnkAcNo: (_c = props.selectedBank) === null || _c === void 0 ? void 0 : _c.bnkAcNo,
                clientCode: (_d = props.clientDetails) === null || _d === void 0 ? void 0 : _d.clientCode,
                ifsc: (_e = props.selectedBank) === null || _e === void 0 ? void 0 : _e.ifscCode,
                mandateType: mandateType,
                // requestedBy: isImpersonated
                //   ? "RM_" + rmDetails
                //   : await accountDetails.getUserID(),
            };
            // if (mandateType === EMandateType.EMANDATE && !isImpersonated)
            /* storing the window reference to window2 variable to change url href
                later once url is fetched from auth-status(getMandateUrl) api as
                async function call issue fails with iphone and other uncompatible browsers */
            // window2 = window.open(
            //   config.rmJourneyBaseRoot + "mutualFunds/redirecting",
            //   "_blank"
            // );
            tocDi.mandate
                .createMandate(payload)
                .then(function (data) {
                var _a;
                if (data.mandateId) {
                    tocDi.mandate
                        .getMfMandate({
                        clientCode: (_a = props.clientDetails) === null || _a === void 0 ? void 0 : _a.clientCode,
                        filterRequired: true,
                    })
                        .then(function (mfMandate) {
                        var _a;
                        if (mfMandate.lst.length > 0) {
                            var updatedMandateList = __spreadArray([], __read(mfMandate.lst), false);
                            var selMandate = updatedMandateList === null || updatedMandateList === void 0 ? void 0 : updatedMandateList.find(function (x) { return x.mandateId === data.mandateId; });
                            setNewMandate(selMandate);
                            if (props.isPayNow) {
                                props.setSelectedMandate(selMandate);
                                props.setSelectedMandateId(selMandate === null || selMandate === void 0 ? void 0 : selMandate.mandateId);
                            }
                            else {
                                updatedMandateList = updatedMandateList.filter(function (item) { return item.dpStatus === "Active"; });
                            }
                            if (mandateType === EMandateType.PHYSICAL)
                                //|| isImpersonated
                                props === null || props === void 0 ? void 0 : props.setMandateFlow(EMandateFlow.UPLOAD);
                            else {
                                if (mandateType === EMandateType.EMANDATE)
                                    props === null || props === void 0 ? void 0 : props.setMandateFlow(EMandateFlow.INFOPAGE);
                                // setTimeout(() => {
                                //   getMandateUrl(data.mandateId);
                                // }, 60000);
                            }
                            (_a = props.setMandateList) === null || _a === void 0 ? void 0 : _a.call(props, updatedMandateList);
                        }
                    })
                        .catch(function (error) {
                        props === null || props === void 0 ? void 0 : props.setMandateFlow(EMandateFlow.CREATE);
                        // window2.location.href =
                        //   config.rmJourneyBaseRoot + "mutualFunds/closing";
                        setTimeout(function () {
                            setShowToastMsg("Facing some technical difficulties, please try later");
                        }, 500);
                    });
                }
                else {
                    props === null || props === void 0 ? void 0 : props.setMandateFlow(EMandateFlow.CREATE);
                    // if (
                    //   mandateType === EMandateType.EMANDATE &&
                    //   !isImpersonated &&
                    //   window2
                    // )
                    //   window2.location.href =
                    //     config.rmJourneyBaseRoot + "mutualFunds/closing";
                    setTimeout(function () {
                        setShowToastMsg("Sorry! Mandate could not be created. " + data.msg);
                    }, 500);
                }
            })
                .catch(function (error) {
                props === null || props === void 0 ? void 0 : props.setMandateFlow(EMandateFlow.CREATE);
                console.log(error);
            })
                .finally(function () { });
            return [2 /*return*/];
        });
    }); };
    var uploadImageSubmit = function (imageData) {
        var payload = {
            img: imageData === null || imageData === void 0 ? void 0 : imageData.base64Data.split(",")[1],
            imgnm: imageData === null || imageData === void 0 ? void 0 : imageData.docFile,
            mndtid: newMandate === null || newMandate === void 0 ? void 0 : newMandate.mandateId,
        };
        tocDi.mandate
            .uploadMandateImg(payload)
            .then(function (data) {
            if (data) {
                props === null || props === void 0 ? void 0 : props.setMandateFlow(EMandateFlow.SHOW);
            }
        })
            .catch(function (error) { return console.log(error); });
        props === null || props === void 0 ? void 0 : props.setMandateFlow(EMandateFlow.SHOW);
    };
    var downloadData = function () {
        var _a;
        tocDi.mandate
            .downloadMandate({
            mandateId: newMandate === null || newMandate === void 0 ? void 0 : newMandate.mandateId,
            clientId: newMandate === null || newMandate === void 0 ? void 0 : newMandate.clientCode,
            bankAccType: (_a = props.selectedBank) === null || _a === void 0 ? void 0 : _a.bankAccType,
        })
            .then(function (data) {
            var _a;
            if (((_a = data.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                base64toPDFforceDownload(data.data, "mandateForm.pdf");
            }
        });
    };
    var rightBtnOnClickforNavigate = function () {
        var redirectParamUrl = "/dashboard/orderbook?productCode=".concat(urlMapper[ESubProductIds.MutualFund]);
        navigate(redirectParamUrl);
        if (props.isTriggeredFromOrderBook) {
            props.hideMfTocSideBar();
        }
    };
    useEffect(function () {
        if (amount && Number(amount) >= 50000) {
            setDisableSubmit(false);
        }
        else {
            setDisableSubmit(true);
        }
    }, [amount]);
    useEffect(function () {
        var accountLastFourDigits = newMandate === null || newMandate === void 0 ? void 0 : newMandate.accountNumber.split("").slice(-4).join("");
        var updatedCreatedOnDate = moment(newMandate === null || newMandate === void 0 ? void 0 : newMandate.createdOn).format("DD MMM YYYY");
        var updatedValidity = moment(newMandate === null || newMandate === void 0 ? void 0 : newMandate.expiryDate).format("DD MMM YYYY");
        // update the statusType in GenericStatus later once confirmation is received from the design team
        var genericDetails = [
            {
                label: "Mandate ID",
                value: "".concat(newMandate === null || newMandate === void 0 ? void 0 : newMandate.shortName, " ").concat(newMandate === null || newMandate === void 0 ? void 0 : newMandate.mandateId),
            },
            {
                label: "Status",
                value: (React.createElement(GenericStatus, { statusText: newMandate === null || newMandate === void 0 ? void 0 : newMandate.mandateStatus, statusType: EGenericStatusType.WARNING })),
            },
            {
                label: "Bank",
                value: "".concat(newMandate === null || newMandate === void 0 ? void 0 : newMandate.bankName, " *").concat(accountLastFourDigits),
            },
            {
                label: "Created on",
                value: "".concat(updatedCreatedOnDate),
            },
            { label: "Validity", value: updatedValidity },
            {
                label: "Amount",
                value: newMandate === null || newMandate === void 0 ? void 0 : newMandate.amount,
                valueType: EValueType.CURRENCY,
            },
        ];
        setGenericDetailsProps(genericDetails);
    }, [newMandate === null || newMandate === void 0 ? void 0 : newMandate.mandateId]);
    var MandateFlowRender = function () {
        var _a, _b;
        switch (props === null || props === void 0 ? void 0 : props.mandateFlow) {
            case EMandateFlow.CREATE:
                return (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: " primary-side-txn-form-container outer-body-section mainScroll scroll-height customScrollUi" },
                        React.createElement(CreateNewMandateData, { hideDiffBank: props.hideDiffBank ? props.hideDiffBank : false, setShow: props.setShow, selectedBank: props.selectedBank, setAmount: setAmount, amount: amount, mandateType: mandateType, setMandateType: setMandateType, bankList: props.bankList, setSelectedBank: props.setSelectedBank, setBack: function () {
                                props.setShow(EMutualFundFlow.PURCHASE);
                            }, setFormErrors: setFormErrors, formErrors: formErrors, isTriggeredFromOrderBook: props.isTriggeredFromOrderBook })),
                    React.createElement("div", { className: "bottom-contents" },
                        React.createElement(SideTxnFooter, { leftBtnText: "Cancel", leftBtnOnClick: function () {
                                if (props.isTriggeredFromOrderBook) {
                                    props.hideMfTocSideBar();
                                }
                                else {
                                    props.setShow(EMutualFundFlow.PURCHASE);
                                }
                            }, rightBtnText: "Authorize Mandate", rightBtnOnClick: onSubmit, isDisableButton: formErrors.amount.status ||
                                disableSubmit ||
                                !((_a = props.selectedBank) === null || _a === void 0 ? void 0 : _a.bnkAcNo) }),
                        showToastMsg && (React.createElement("div", { className: "primary-place-order-toast-container" },
                            React.createElement(ToastContainer, { position: "bottom-center" },
                                React.createElement(Toast, { show: showToastMsg.length > 0 ? true : false, delay: 4000, onClose: function () {
                                        setShowToastMsg("");
                                        setDisableSubmit(false);
                                    }, autohide: true, className: "secondary-place-order-mfcontainer DMSans_13_400 d-flex align-items-center justify-content-start w-100" },
                                    React.createElement("div", { className: "d-flex flex-row place-order-toast-inner-text align-items-center gap-2" },
                                        React.createElement("i", { className: "edel-icon-error-thin" }),
                                        React.createElement("label", { className: "" }, showToastMsg)),
                                    React.createElement("div", null,
                                        React.createElement(Edelicon, { className: "edel-icon-close cursor-pointer", onClick: function () { return setShowToastMsg(""); } }))))))))) : (React.createElement(React.Fragment, null,
                    React.createElement(GenericDrawer, { show: props.show, setShow: function () { return props.setShow(EMutualFundFlow.PURCHASE); }, headerComp: React.createElement(React.Fragment, null,
                            React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1 cursorOnHover" }, "Create New Mandate")), bodyComp: React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "outer-body-section iphone-scroll" },
                                React.createElement(CreateNewMandateData, { hideDiffBank: props.hideDiffBank ? props.hideDiffBank : false, setShow: props.setShow, selectedBank: props.selectedBank, setAmount: setAmount, amount: amount, mandateType: mandateType, setMandateType: setMandateType, bankList: props.bankList, setSelectedBank: props.setSelectedBank, setBack: function () {
                                        props.setShow(EMutualFundFlow.PURCHASE);
                                    } })),
                            React.createElement(SideTxnFooter, { leftBtnText: "Back", leftBtnOnClick: function () {
                                    props.setShow(EMutualFundFlow.PURCHASE);
                                }, isDisableButton: disableSubmit || !((_b = props.selectedBank) === null || _b === void 0 ? void 0 : _b.bnkAcNo), rightBtnText: "Authorize Mandate", rightBtnOnClick: onSubmit })) })))));
            case EMandateFlow.UPLOAD:
                return (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "primary-validate-mandate-form-container mainScroll scroll-height customScrollUi" },
                        React.createElement(SignOnMandate, { onSubmit: function (data) { return uploadImageSubmit(data); }, onDownload: function () { return downloadData(); }, onBackClick: function () {
                                props === null || props === void 0 ? void 0 : props.setMandateFlow(EMandateFlow.CREATE);
                            } })),
                    React.createElement("div", { className: "bottom-contents" },
                        React.createElement(SideTxnFooter, { leftBtnText: "Back", leftBtnOnClick: function () {
                                props === null || props === void 0 ? void 0 : props.setMandateFlow(EMandateFlow.CREATE);
                            }, rightBtnText: "View Orderbook", rightBtnOnClick: rightBtnOnClickforNavigate })))) : (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "bg-white" },
                        React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Sign on your mandate"),
                        React.createElement(SignOnMandate, { onSubmit: uploadImageSubmit, onDownload: function () { return downloadData(); }, onBackClick: function () {
                                props === null || props === void 0 ? void 0 : props.setMandateFlow(EMandateFlow.CREATE);
                            } }),
                        React.createElement("div", { className: "bottom-contents" },
                            React.createElement(SideTxnFooter, { leftBtnText: "Back", leftBtnOnClick: function () {
                                    props === null || props === void 0 ? void 0 : props.setMandateFlow(EMandateFlow.CREATE);
                                }, rightBtnText: "Back to transaction", rightBtnOnClick: function () { } })))))));
            case EMandateFlow.SHOW:
                return (React.createElement(NewMandate, { selectedBank: props.selectedBank, show: true, setShow: props.setShow, selectedMandate: newMandate, onClose: function () { return props.setSelectedMandate(newMandate); } }));
            case EMandateFlow.INFOPAGE:
                return (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "parent-Emandate-info-container" },
                        React.createElement("main", { className: "emandate-container  d-flex flex-column align-items-center" },
                            React.createElement(EmandateInfoPage, { isFromMandate: true, iconSrc: MandateStatus, title: "A new mandate has been initiated.", description: "The client will receive an email with detailed information about the mandate procedure.", genericDetailsProps: genericDetailsProps }))),
                    React.createElement("div", { className: "bottom-contents" },
                        React.createElement(SideTxnFooter, __assign({ leftBtnText: "Close", leftBtnOnClick: function () {
                                if (props.isTriggeredFromOrderBook) {
                                    props.hideMfTocSideBar();
                                }
                                else {
                                    props.setShow(EMutualFundFlow.PURCHASE);
                                }
                            } }, (!props.isTriggeredFromOrderBook && {
                            rightBtnText: "Back to transaction",
                            rightBtnOnClick: function () {
                                props.setShow(EMutualFundFlow.PURCHASE);
                            },
                        })))))) : (React.createElement(React.Fragment, null,
                    React.createElement(GenericDrawer, { show: props.show, setShow: function () { return props.setShow(EMutualFundFlow.PURCHASE); }, headerComp: React.createElement(React.Fragment, null,
                            React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Mandate Creation in Process")), bodyComp: React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "parent-Emandate-info-container" },
                                React.createElement("main", { className: "emandate-container  d-flex flex-column align-items-center" },
                                    React.createElement(EmandateInfoPage, { isFromMandate: true, iconSrc: MandateStatus, title: "A new mandate has been initiated.", description: "The client will receive an email with detailed information about the mandate procedure." }))),
                            React.createElement("div", { className: "bottom-contents" },
                                React.createElement(SideTxnFooter, { leftBtnText: "Back", leftBtnOnClick: function () {
                                        props.setShow(EMutualFundFlow.PURCHASE);
                                    }, rightBtnText: "Authorize Mandate", rightBtnOnClick: onSubmit }))) })))));
            case EMandateFlow.LOADER:
                return React.createElement(Loader, null);
        }
    };
    return React.createElement(React.Fragment, null, MandateFlowRender());
};
export default CreateNewMandate;
